const Socketconfig = () => {
  console.log("process.env.NODE_ENV",process.env.NODE_ENV);
  console.log("window.location.host",window.location.host);
  console.log("window.location.protocol",window.location.protocol);
  if (process.env.NODE_ENV === 'production') {
    // In production, use the same host as the current page
    return `${window.location.protocol === 'https:' ? 'wss:' : 'ws:'}//${window.location.host}/ws`; 
  } else {
    // In development, use localhost with the appropriate port
    return 'http://localhost:5000';
  }
};

export const WEBSOCKET_URL = Socketconfig();